import { track } from '../analytics/index.js';
import { useConfig, usePrice, useValidation } from '../state/hooks.js';

export function AddToCartButton() {
  const config = useConfig();
  const price = usePrice();
  const validation = useValidation();

  const handleClick = () => {
    if (!validation.ok) {
      track({ name: 'validation_failed', errorCodes: validation.errors.map((e) => e.code) });
      return;
    }
    track({ name: 'add_to_cart_clicked', total: price.total, quantity: config.quantity });
    // Stub: in Phase 3 this will postMessage the parent (WP plugin) which performs
    // server-side re-validation, server-side price recalc, and adds to the WC cart.
    // eslint-disable-next-line no-console
    console.log('[configurator] Add to Cart (stub)', { config, price });
  };

  return (
    <button
      type="button"
      className="add-to-cart"
      onClick={handleClick}
      disabled={!validation.ok}
    >
      Add to Cart — {`$${price.total.toFixed(2)}`}
    </button>
  );
}
